module.exports = __webpack_public_path__ + "img/v3.2.3eaf648c.png";